import { css } from "@emotion/react";
import Dialog from "../Dialog/Dialog";
import { BodyRegular14, H6Css, Heading } from "../Typography";
import { Props } from "react-modal";
import { darkColor, textColor } from "@/constants/colors";
import HR from "../HR/HR";
import Button from "../Buttons/Button";
import Link from "next/link";
import { signInUrl } from "@/constants/paths";
import { mq } from "@/constants/breakpoints";

interface UserExistsErrorDialogProps extends Props {}

const UserExistsErrorDialog = ({
  isOpen,
  onRequestClose,
}: UserExistsErrorDialogProps) => {
  return (
    <Dialog isOpen={isOpen} onRequestClose={onRequestClose}>
      <div
        css={css`
          text-align: center;
        `}
      >
        <Heading
          css={css`
            color: ${darkColor};
            ${H6Css}
          `}
        >
          Email In Use
        </Heading>
        <BodyRegular14
          css={css`
            margin-top: 14px;
            color: ${textColor};
          `}
        >
          This email has already been taken. If you&apos;d like to sign in
          instead, click the button below. Otherwise, please use a different
          email to create a new account. Thanks!
        </BodyRegular14>
      </div>
      <div
        css={css`
          margin: 20px 0;
        `}
      >
        <HR />
      </div>
      <div
        css={css`
          display: flex;
          justify-content: space-between;
          flex-direction: column-reverse;
          margin: auto;
          gap: 15px;
          width: fit-content;
          ${mq["sm"]} {
            width: unset;
            flex-direction: row;
          }
        `}
      >
        <Button jwType="light" onClick={onRequestClose}>
          Cancel
        </Button>
        <Link
          href={signInUrl}
          css={css`
            width: fit-content;
          `}
        >
          <Button jwType="dark">Sign In</Button>
        </Link>
      </div>
    </Dialog>
  );
};

export default UserExistsErrorDialog;
